<template>
  <v-dialog v-model="_openDialog" scrollable persistent transition="dialog-bottom-transition" max-width="1000">
    <validation-observer v-slot="{ valid }">
      <v-card>
        <v-card-title class="headline my-3">Criar arquivo modelo de Caderno de Serviços</v-card-title>
        <v-card-text>
          <v-row class="mx-auto">
            <v-col cols="12">
              <v-alert dense outlined type="info" color="blue" class="pa-2">
                Realize a filtragem dos lançamentos que devem ir para o Caderno de Serviços
              </v-alert>
              <v-alert dense outlined type="info" color="blue" class="pa-2">Utilize pelo menos um filtro</v-alert>

              <validation-provider rules="required" immediate>
                <input v-model="minOneFilterSelected" type="hidden" name="valida-filtragem-minima" />
              </validation-provider>
            </v-col>
          </v-row>

          <v-row class="mx-auto">
            <v-col cols="12">
              <validation-provider id="nome-modelo-caderno-servicos" v-slot="{ errors }" rules="required|max:60">
                <v-text-field v-model="nome" label="Nome" outlined :error-messages="errors" />
              </validation-provider>
            </v-col>
            <v-col cols="9">
              <v-textarea
                id="obras-saneamento-voc"
                v-model="filtros.obras"
                class="mt-0 pt-0"
                label="Obras"
                placeholder="Insira os códigos das obras, um por linha. Ex.:

      CI1944457111 
      CI1944457348"
                rows="5"
                no-resize
                clearable
                clear-icon="mdi-close-circle"
              />
            </v-col>
            <v-col id="obras-nao-pertence-saneamento-voc" class="mt-12 pl-0" cols="3">
              <v-checkbox v-model="filtros.obrasNaoPertencem" class="my-0 py-0" hide-details label="Não pertence" />
            </v-col>
          </v-row>

          <v-row class="mx-auto">
            <v-col cols="9">
              <v-textarea
                id="tipologias-saneamento-voc"
                v-model="filtros.tipologias"
                class="mt-0 pt-0"
                label="Tipologias"
                placeholder="Insira os códigos das tipologias, um código por linha. Ex.: 

      RAU
      RAR"
                rows="5"
                no-resize
                clearable
                clear-icon="mdi-close-circle"
              />
            </v-col>
            <v-col id="tipologias-nao-pertence-saneamento-voc" class="mt-12 pl-0" cols="3">
              <v-checkbox v-model="filtros.tipologiasNaoPertencem" class="my-0 py-0" hide-details label="Não pertence" />
            </v-col>
          </v-row>

          <v-row id="data-imobilizacao-saneamento-voc" class="mx-auto">
            <v-col class="pb-0 pt-1" cols="5">
              <v-menu
                v-model="menuPickerImob[0]"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :rules="{
                      required_if: filtros.dataImob.fimFormatted != null && filtros.dataImob.fimFormatted.length > 0,
                      min: 10
                    }"
                  >
                    <v-text-field
                      v-model="filtros.dataImob.inicioFormatted"
                      v-mask="'##/##/####'"
                      :error-messages="errors"
                      class="pt-0"
                      label="Data Imobilização"
                      prepend-icon="mdi-calendar"
                      clearable
                      v-bind="attrs"
                      v-on="on"
                      @blur="filtros.dataImob.inicio = parseDate(filtros.dataImob.inicioFormatted)"
                    />
                  </validation-provider>
                </template>
                <v-date-picker
                  v-model="filtros.dataImob.inicio"
                  locale="pt-br"
                  @input="
                    menuPickerImob[0] = false;
                    filtros.dataImob.inicioFormatted = formatDate(filtros.dataImob.inicio);
                  "
                />
              </v-menu>
            </v-col>
            <v-col class="pb-0 pt-5 text-center" style="min-width: 60px !important" cols="2">
              <span style="color: rgba(0, 0, 0, 0.54); font-size: 15px">até</span>
            </v-col>
            <v-col class="pb-0 pt-1" cols="5">
              <v-menu
                v-model="menuPickerImob[1]"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :rules="{
                      required_if: filtros.dataImob.inicioFormatted != null && filtros.dataImob.inicioFormatted.length > 0,
                      min: 10
                    }"
                  >
                    <v-text-field
                      v-model="filtros.dataImob.fimFormatted"
                      v-mask="'##/##/####'"
                      :error-messages="errors"
                      class="pt-0"
                      label="Data Imobilização"
                      prepend-icon="mdi-calendar"
                      clearable
                      v-bind="attrs"
                      v-on="on"
                      @blur="filtros.dataImob.fim = parseDate(filtros.dataImob.fimFormatted)"
                    />
                  </validation-provider>
                </template>
                <v-date-picker
                  v-model="filtros.dataImob.fim"
                  locale="pt-br"
                  @input="
                    menuPickerImob[1] = false;
                    filtros.dataImob.fimFormatted = formatDate(filtros.dataImob.fim);
                  "
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn v-show="!processandoArquivoModelo" color="primary" text @click="_openDialog = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="processandoArquivoModelo" :disabled="!valid" @click="getArquivoPadrao()">Criar</v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-dialog>
</template>

<script>
  import ModelosCadernosServicosService from '@/services/parametrosComCa/ModelosCadernosServicosService';
  import DateFormatterMixins from '@/mixins/dateFormatterMixins.js';

  export default {
    name: 'DialogDownloadArquivo',

    mixins: [DateFormatterMixins],

    props: {
      openDialog: {
        type: Boolean,
        required: true
      }
    },

    emits: ['created', 'update:openDialog'],

    data() {
      return {
        menuPickerImob: [false, false],
        nome: '',
        filtros: {
          obras: '',
          tipologias: '',
          obrasNaoPertencem: false,
          tipologiasNaoPertencem: false,
          dataImob: {
            inicioFormatted: '',
            inicio: '',
            fimFormatted: '',
            fim: ''
          }
        },
        processandoArquivoModelo: false
      };
    },

    computed: {
      minOneFilterSelected() {
        return this.filtros.obras || this.filtros.tipologias || (this.filtros.dataImob.inicio && this.filtros.dataImob.fim)
          ? true
          : undefined;
      },
      _openDialog: {
        get() {
          return this.openDialog;
        },
        set(newValue) {
          this.$emit('update:openDialog', newValue);
        }
      }
    },

    methods: {
      getArquivoPadrao() {
        this.processandoArquivoModelo = true;

        const data = {
          nome: this.nome,
          dataImobilizacaoInicial: this.filtros.dataImob.inicio,
          dataImobilizacaoFinal: this.filtros.dataImob.fim,
          obras: this.filtros.obras,
          tipologias: this.filtros.tipologias,
          obrasNaoPertencem: this.filtros.obrasNaoPertencem,
          tipologiasNaoPertencem: this.filtros.tipologiasNaoPertencem
        };

        ModelosCadernosServicosService.criar(data)
          .then(() => {
            this.$toast.info('Seu arquivo será gerado em breve, por favor aguarde', '', { position: 'topRight', timeout: 5000 });

            this._openDialog = false; // fecha o dialog
            this.$emit('created');
          })
          .catch((err) => {
            this.$toast.error('Erro ao criar arquivo modelo de Caderno de Serviços', '', { position: 'topRight' });
            console.error(err);
          })
          .finally(() => (this.processandoArquivoModelo = false));
      }
    }
  };
</script>

<style></style>
